(function () {
  const STORAGE_KEY = 'rockyzSale10AutoApplyAttempted';
  const SALE_CODE = 'SALE10';
  const DEADLINE = new Date('2026-09-01T19:20:00Z').getTime();

  async function tryApply() {
    if (Date.now() >= DEADLINE) return;
    if (sessionStorage.getItem(STORAGE_KEY)) return;

    let cart;
    try {
      cart = await fetch('/cart.js').then((r) => r.json());
    } catch (e) {
      return;
    }
    if (!cart || cart.item_count === 0) return;
    if (cart.discount_codes && cart.discount_codes.some((d) => d.applicable)) return;

    sessionStorage.setItem(STORAGE_KEY, 'true');

    try {
      const res = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: SALE_CODE }),
      });
      if (!res.ok) return;
      const updatedCart = await res.json();

      const updateEvent = new Event('shopify:cart:lines-update', { bubbles: true });
      updateEvent.action = 'discount';
      updateEvent.context = 'cart';
      updateEvent.lines = [];
      updateEvent.promise = Promise.resolve({
        cart: {
          id: updatedCart.token,
          totalQuantity: updatedCart.item_count,
          cost: {
            totalAmount: { amount: String(updatedCart.total_price / 100), currencyCode: updatedCart.currency },
          },
          lines: [],
          discountCodes: updatedCart.discount_codes || [],
        },
        detail: {
          items: updatedCart.items,
          itemCount: updatedCart.item_count,
          source: 'cart-auto-discount',
          didError: false,
        },
      });
      document.dispatchEvent(updateEvent);
    } catch (e) {
      // silently ignore — the discount accordion is still there as a manual fallback
    }
  }

  tryApply();
  document.addEventListener('shopify:cart:lines-update', () => {
    if (!sessionStorage.getItem(STORAGE_KEY)) tryApply();
  });
})();
